module.exports = __webpack_public_path__ + "static/media/infoWhite.5497a6c5.svg";